import React, {useState} from "react";
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer";
import { useForm ,Controller} from "react-hook-form";
import PhoneInput from 'react-phone-number-input';
import './ContactSales.css'
import ApiService from '../../classes/ApiService';
import Alert from 'react-bootstrap/Alert';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Form, Button } from 'react-bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import { Link } from "react-router-dom";
const ContactSales = ()=> {

    const [errorMessage, setErrorMessage] = useState({error: false, header: '', message: ''});
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const modalContent = {
        header: "Message Received!",
        body: "Thank you for reaching out to us. Our team has received your message and will get back to you shortly.",
        variant: "success",
    };

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required('First Name is required'),
        lastName: Yup.string().required('Last Name is required'),
        phone: Yup.string()
            .required('Phone number is required').min(12, 'Phone number must be at least 10 digits'),
        email: Yup.string().email('Email is invalid').required('Email is required'),
        message: Yup.string().required('Message is required'),
    });

    const { register, handleSubmit, formState: { errors }, reset, control } = useForm({
        resolver: yupResolver(validationSchema)
    });
    
    const onSubmit = async (data) => {
        try {
            setLoading(true);
            setShowAlert(false);
            const apiService = new ApiService();

            //Call the API to submit the form data
            const response = await apiService.post('/forms/website/contact', {
                first_name: data.firstName || 'First Name',
                last_name: data.lastName || 'Last Name',
                phone_number: data.phone || 'Phone Number',
                email_address: data.email || 'Email Address',
                message: data.message || 'Message',
               source: 'investor'
             });
   
            //Check if the form was submitted successfully
            if (response.success === true) {
                setErrorMessage({error: false, header: '', message: ''});
                setShowAlert(true);
                reset();
                setLoading(false);
            } else if (response.success === true && response.data?.message) {
                //We got a 200 response but with an error message
                console.error('Error submitting form:', response.data.message);
                setErrorMessage({error: true, header: 'Error!', message: response.data.message, variant: 'danger'});
                setShowAlert(true);
                setLoading(false);
            }
        } catch (error) {
            if (error.response?.data?.message) {
                console.error('Error submitting form:', error.response.data.message);
                setErrorMessage({error: true, header: 'Error!', message: error.response.data.message, variant: 'danger'});
                setShowAlert(true);
            } else {
                console.error('Error submitting form:', error);
            }
            setLoading(false);
        }
    };
    return (
        <>
          <AIheader/>
            <section className="contactSalesMain">
                <div className="container">
                    <div className="row justify-content-center">
                        {/* START Left Section */}
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="contactSalesLeft">
                            <h2>Contact our sales team</h2>
                            <Alert variant={errorMessage.error ? errorMessage.variant : modalContent.variant} show={showAlert} onClose={() => setShowAlert(false)} dismissible>
                                <Alert.Heading>{errorMessage.error ? errorMessage.header : modalContent.header}</Alert.Heading>
                                <p>
                                    {errorMessage.error ? errorMessage : modalContent.body}
                                </p>
                            </Alert>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="first_name">First Name<span className="required">*</span></Form.Label>
                                            <Form.Control required type="text" id="first_name" placeholder='Enter first name' name="waitlist[first_name]" {...register('firstName')}
                                            disabled={loading}/>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.firstName?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="last_name">Last Name<span className="required">*</span></Form.Label>
                                            <Form.Control required type="text" id="last_name" placeholder='Enter last name' name="lastName" {...register('lastName')}
                                            disabled={loading}/>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.lastName?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    
                                    <div className="col-lg-6 col-md-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="email_address">Email address<span className="required">*</span></Form.Label>
                                            <Form.Control required type="email" id="email_address" placeholder='Enter your email' name="email" {...register('email')}
                                                isInvalid={!!errors.email} disabled={loading}/>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="job_title">Job Title<span className="required">*</span></Form.Label>
                                            <Form.Control required type="text" id="job_title" placeholder='Enter Title' name="job_title" {...register('JobTitle')}
                                            disabled={loading}/>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.job_title?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                    <div className="col-lg-12 col-md-12">  
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="phone_number">
                                                Phone Number<span className="required">*</span>
                                            </Form.Label>
                                            <Controller
                                                name="phone"
                                                control={control}
                                                disabled={loading}
                                                rules={{
                                                    required: "Phone number is required",
                                                    validate: (value) => (value && value.length >= 12) || "Phone number must be valid",
                                                }}
                                                render={({ field }) => (
                                                    <PhoneInput
                                                        disabled={loading}
                                                        {...field}
                                                        id="phone_number"
                                                        limitMaxLength={true}
                                                        defaultCountry="US"
                                                        placeholder="XXX-XXX-XXX"
                                                        onChange={(value) => field.onChange(value)} // Ensure React Hook Form value updates
                                                        value={field.value || ''}
                                                    />
                                                )}
                                            />
                                            {errors.phone && (
                                                <Form.Control.Feedback type="invalid" className="d-block">
                                                    {errors.phone.message}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </div>

                                    <div className="col-lg-6 col-md-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="company_name">Company Name<span className="required">*</span></Form.Label>
                                            <Form.Control required type="text" id="company_name" placeholder='Enter Company Name' name="company_name" {...register('JobTitle')}
                                            disabled={loading}/>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.company_name?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6 col-md-6 select_3">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="company_size">Company size</Form.Label>
                                            <select className="selectpicker" id="company_size" name="company_size" {...register('company_size')} isInvalid={!!errors.fleet}>
                                                <option value="">Select</option>
                                                <option value="1">1</option>
                                                <option value="2 to 5">2 to 5</option>
                                                <option value="5 to 10">5 to 10</option>
                                                <option value="Greater than 10">Greater than 10</option>
                                            </select>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.company_size?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                    <div className="col-lg-12 col-md-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="company_manage">What would you like to manage with rentid?</Form.Label>
                                            <select className="selectpicker" id="company_manage" name="company_manage" {...register('company_manage')} isInvalid={!!errors.fleet}>
                                                <option value="">Select</option>
                                                <option value="General">General</option>
                                                <option value="RentDirect – Rental Operations">RentDirect – Rental Operations</option>
                                                <option value="RentID – Trust & Verification">RentID – Trust & Verification</option>
                                                <option value="RentShield – Insurance & Protection">RentShield – Insurance & Protection</option>
                                                <option value="RentAI – Automation & Intelligence">RentAI – Automation & Intelligence</option>
                                                <option value="RentSuccess – Support & Resolution">RentSuccess – Support & Resolution</option>
                                                <option value="RentAcademy – Learning & Growth">RentAcademy – Learning & Growth</option>
                                                <option value="All of the above">All of the above</option>
                                                <option value="Something else">Something else</option>
                                            </select>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.company_manage?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                    <div className="col-lg-12 col-md-12">
                                        <div className="mb-4">
                                            <label className="form-label">How can our team help you? <span className="required">*</span></label>
                                            <textarea disabled={loading}
                                            {...register("message", { required: true })}
                                            className="form-control"
                                            placeholder="Let us know how we can help your business"
                                            rows="3"
                                            ></textarea>
                                            {errors.message && (
                                            <div className="text-danger small">Message is required</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 text-center">
                                        <Button disabled={loading} type="submit" className="btn btnBlue">{loading ? "Submitting..." : "Submit"}</Button>
                                    </div>
                                </div>
                            </Form>
                            </div>
                        </div>
                        {/* END Left Section */}

                        {/* START Right Section */}
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="contactSalesRight"> 
                                <div className="contactSalesRight_1"> 
                                    <h2>Rent, verify, protect, grow<br/> and scale, in one place.</h2>
                                    <div className='placeContactOuter'>
                                        <div className="placeContactLeft">
                                            <img heigh="36px" src="/img/hands_contact.svg" alt="Available nationwide"/>
                                            <h3>Available <br/>nationwide</h3> 
                                        </div>
                                        <div className="placeContactRight">
                                            <p>Schedule a meeting to learn how <br/>renitd.io can fit your business needs.</p>
                                        </div>
                                    </div>
                                    <div className='placeContactOuter'>
                                        <div className="placeContactLeft">
                                            <img heigh="36px" src="/img/r_logo_contact.svg" alt="Solutions for all businesses"/>
                                            <h3>Solutions for <br/>all businesses</h3> 
                                        </div>
                                        <div className="placeContactRight">
                                            <p>Explore solutions and pricing <br/>based on your goals and priorities.</p>
                                        </div>
                                    </div>
                                    <div className='placeContactOuter'>
                                        <div className="placeContactLeft">
                                            <img heigh="36px" src="/img/car_contact.svg" alt="industries"/>
                                            <h3>Serving 12+ <br/>industries</h3> 
                                        </div>
                                        <div className="placeContactRight">
                                            <p>Increase productivity from day <br/>one with rentid workflows & tools.</p>
                                        </div>
                                    </div>
                                    <p> To learn more now, visit our <a href="https://rentid.io/" target="_blank">www.rentitd.io</a></p>
                                </div>

                                <div className='contactSalesBottom'> 
                                    <h3><span>“rentid</span> is everything we needed take control of our<br/> car rental business. 
                                    We're just getting started.”</h3> 
                                    <p>Current Customer | Los Angeles, CA | Marketplace Host</p>
                                </div>
                                <div className='contactSalesRent'> 
                                <ul>
                                    <li>
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent id"/>rent<span>direct</span>
                                    </li>
                                    <li>
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </li>
                                    <li>
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent id"/>rent<span>shield</span>
                                    </li>
                                    <li>
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent id"/>rent<span>AI</span>
                                    </li>
                                    <li>
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent id"/>rent<span>success</span>
                                    </li>
                                    <li>
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent id"/>rent<span>academy</span>
                                    </li>
                                </ul>
                                </div>


                            </div>
                        </div>
                        {/* END Right Section */}
                    </div>
                </div>
            </section>
        <Footer/>
        </>
    )
}
export default ContactSales;